module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error && _vm.error != ''),
      expression: "error && error != ''"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.userFullName.length) ? _c('article', {
    staticClass: "tile is-child box"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              氏名:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.userFullName))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              社員番号:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_code))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              入社日:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.start_from))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              採用形態:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.contract_type))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              Status:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.statusToLabel(_vm.timesheetData ? _vm.timesheetData.status : null))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              会社名:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.user.vti_group === 'VTI Japan' ? '株式会社VTIジャパン' : '株式会社VTIコーポレーション') + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              報告年月:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.currentMonth))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              所定労働時間:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.working_hour))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              休憩時間:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.break_time_format))])])]), _vm._v(" "), (_vm.timesheetData) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              Admin's message:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.timesheetData.note))])])]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "control is-pulled-left"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.backHistory
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Back")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered"
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n            " + _vm._s(header) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.previewData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      class: {
        'is-off-work': _vm.weekendAndHoliday(item)
      }
    }, [_vm._v(_vm._s(item.day_in_week))]), _vm._v(" "), _c('td', {
      class: {
        'is-off-work': _vm.offWork(item)
      }
    }, [((!_vm.empty(item.is_substitute_dayoff) || (item.is_off_work && !_vm.empty(item.ot_time_start))) && _vm.isWorking(item)) ? [_vm._v("\n              " + _vm._s(_vm.substituteTxt) + "\n            ")] : (!_vm.empty(item.type)) ? [(item.type === _vm.dayOffType.SUBSTITUTE) ? [_vm._v("\n                " + _vm._s(_vm.substituteDayOffTxt) + "\n              ")] : (item.type === _vm.dayOffType.HALF_DAY || _vm.isHalfWorking(item)) ? [_vm._v("\n                " + _vm._s(_vm.halfDayOffTxt) + "\n              ")] : (item.type === _vm.dayOffType.NOT_ALLOWED) ? [_vm._v("\n                " + _vm._s(_vm.absenceTxt) + "\n              ")] : ((!_vm.empty(item.is_off_work) || !_vm.empty(item.is_off_day)) && _vm.empty(item.ot_time_start)) ? [_vm._v("\n                " + _vm._s(_vm.holidayTxt) + "\n              ")] : _vm._e()] : (_vm.weekDay(item.date.date) === 0 || _vm.weekDay(item.date.date) === 6) ? [_vm._v("\n              " + _vm._s(_vm.holidayTxt) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.start_working_time) && _vm.isWorking(item) ? item.start_working_time : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.end_working_time) && _vm.isWorking(item) ? item.end_working_time : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.real_lunch_time) && _vm.isWorking(item) ? item.real_lunch_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [(!_vm.empty(item.type) && item.type === _vm.dayOffType.SUBSTITUTE) ? [_vm._v("\n              " + _vm._s(_vm.isHalfWorking(item) ? 0.5 : 1) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', [(!_vm.empty(item.working_out) && (item.type === _vm.dayOffType.ALLOWED || item.type === _vm.dayOffType.LAST_YEAR)) ? [_vm._v("\n              " + _vm._s(_vm.isHalfWorking(item) ? 0.5 : 1) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.working_out) && _vm.isWorking(item) ? item.working_out : '') + "\n          ")]), _vm._v(" "), _c('td', [(!_vm.empty(item.working_out) && _vm.empty(item.is_off_work)) ? [(item.type === _vm.dayOffType.NOT_ALLOWED) ? [_vm._v("\n                " + _vm._s(1) + "\n              ")] : (item.type === _vm.dayOffType.HALF_DAY) ? [_vm._v("\n                " + _vm._s(0.5) + "\n              ")] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_time) && _vm.empty(item.is_off_work) ? item.over_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_night_time) && _vm.empty(item.is_off_work) ? item.over_night_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_time) && !_vm.empty(item.is_off_work) ? item.over_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_night_time) && !_vm.empty(item.is_off_work) ? item.over_night_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', {
      class: {
        'is-off-work': _vm.holidayOff(item)
      }
    }, [(!_vm.empty(item.note)) ? [_vm._v("\n              " + _vm._s(item.note) + "\n            ")] : (item.is_substitute_dayoff !== null && !_vm.empty(item.is_off_work) && !_vm.empty(item.ot_time_start) && _vm.isWorking(item)) ? [(!_vm.empty(item.is_substitute_dayoff)) ? [_vm._v("\n                " + _vm._s(_vm.holidayWorkSubstitute) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.holidayWorkOT) + "\n              ")]] : (!_vm.empty(item.type)) ? [(_vm.allDayType[item.type]['is_off_day']) ? [_vm._v("\n                " + _vm._s(_vm.allDayType[item.type]['type_name']) + "\n              ")] : (item.is_holiday) ? [_vm._v("\n                " + _vm._s(_vm.allDayType[_vm.dayOffType.JAPAN_HOLIDAY]['type_name']) + "\n              ")] : _vm._e()] : _vm._e()], 2)])
  }), _vm._v(" "), (_vm.previewData) ? _c('tr', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "italic"
    }
  }, [_c('td', {
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v("合計")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.break))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumSubstitute))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumAllowedDayOff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalWork))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumNotAllowedDayOff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalOT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalNightOT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalHolidayOT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalHolidayNightOT))]), _vm._v(" "), _c('td')]) : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0962c5a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/timesheet/PreviewTimesheet.vue
// module id = 359
// module chunks = 66